import { IdentityDocument } from '../model'
import { Country } from '@afterpaytouch/portal-api'
import { useFlag } from '@afterpaytouch/feature'

const DEFAULT_DOCUMENTS: IdentityDocument[] = ['licence', 'passport']
const DEFAULT_ALLOWED_DOCUMENTS = {
  [Country.AU]: ['licence', 'medicare', 'passport'],
  [Country.GB]: ['licence', 'passport'],
}

export const useAllowedDocumentsByCountry = (country: Country | undefined): IdentityDocument[] => {
  const allowedDocuments = useFlag('allowed-documents-by-country', DEFAULT_ALLOWED_DOCUMENTS)

  if (country === undefined) {
    return DEFAULT_DOCUMENTS
  }
  return allowedDocuments[country] || DEFAULT_ALLOWED_DOCUMENTS[country] || DEFAULT_DOCUMENTS
}
